/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {PropTypes} from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';
import Typography, {TypographyProps} from '@material-ui/core/Typography';
import classnames from 'classnames';
import {BodyTypographyVariantEnum} from '@/types/';
import {dlsColor} from '../theme/theme';

export interface BodyTypographyProps extends TypographyProps {
  children: string | JSX.Element;
  variant?: keyof typeof BodyTypographyVariantEnum;
  align?: PropTypes.Alignment
}

const useStyles = makeStyles(theme => ({
  body1 : {
    color : dlsColor('grey3')
  },
  body2 : {
    color : dlsColor('grey1')
  }
}));

/**
 *
 * @BodyTypography
 *
 * DLS Foundational Design Typography Body text:
 * https://www.figma.com/file/gtF4hB3eC4fvzKVJ2DNDtu/01_DLS_Foundation?node-id=1244%3A34
 *
 * ```typescript
 *
 * import React from 'react';
 * import { BodyTypography } from '@ion/dls/src/typography';
 *
 * function MyComponent {
 *   return (
 *     <React.Fragment>
 *       <BodyTypography>body1</BodyTypography>
 *       <br />
 *       <BodyTypography variant='body2'>body2</BodyTypography>
 *     </React.Fragment>
 *   );
 * }
 *
 * ```
 *
 */
const BodyTypography = ({
  children,
  variant = 'body1',
  align = 'left',
  ...props
}: BodyTypographyProps) => {
  const classes = useStyles();
  return (
    <Typography variant={variant}
      className={classnames(classes[variant], props.className)}
      align={align}
      {...props}>
      {children}
    </Typography>
  );
};
export {BodyTypography};
